if (typeof global !== "undefined" && typeof global.self === 'undefined') {
  global.self = {};
  global.__pretenderNodePolyfill = true;
}



//////////////////
// WEBPACK FOOTER
// ./~/@miragejs/pretender-node-polyfill/before.js
// module id = 596
// module chunks = 158